(function () {
    // Embeds written into post bodies without loading="lazy" start downloading
    // the YouTube player (~1 MB each) the moment the page parses. Swap every
    // off-screen one for a lazy clone: the clone looks identical, and the
    // browser only loads it when the reader scrolls near it.
    function run() {
        var limit = window.innerHeight * 1.5;
        document.querySelectorAll('iframe:not([loading])').forEach(function (f) {
            var src = f.getAttribute('src');
            if (!src || !/^https?:\/\//.test(src)) return;
            if (f.getBoundingClientRect().top < limit) { f.setAttribute('loading', 'eager'); return; }
            var lazy = f.cloneNode(false);
            lazy.setAttribute('loading', 'lazy');
            f.parentNode.replaceChild(lazy, f);
        });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
